import { isSelfHostedDistribution } from "utils/distribution";

import useSelfHostedFlags from "./useSelfHostedFlags";
import useTypedFlags from "./useTypedFlags";

const isSelfHosted = isSelfHostedDistribution();

const useAacFlags = () => {
  const { orgSettingsForSpaceAdmins, nonRootAdminRoleBindings } = useTypedFlags();
  const {
    orgSettingsForSpaceAdmins: orgSettingsForSpaceAdminsSelfHosted,
    nonRootAdminRoleBindings: nonRootAdminRoleBindingsSelfHosted,
  } = useSelfHostedFlags();

  if (isSelfHosted) {
    return {
      orgSettingsForSpaceAdmins: orgSettingsForSpaceAdminsSelfHosted,
      nonRootAdminRoleBindings: nonRootAdminRoleBindingsSelfHosted,
    };
  }

  return {
    orgSettingsForSpaceAdmins,
    nonRootAdminRoleBindings,
  };
};

export default useAacFlags;
